import { useMemo, useCallback } from 'react';
import { CACHE_CONFIG } from './cache';

// Memoize expensive calculations
export function useMemoizedValue(value, deps = [], ttl = CACHE_CONFIG.ttl.medium) {
  return useMemo(() => {
    const now = Date.now();
    return {
      value,
      expiry: now + ttl
    };
  }, deps);
}

// Memoize callbacks with TTL
export function useMemoizedCallback(callback, deps = [], ttl = CACHE_CONFIG.ttl.medium) {
  return useCallback((...args) => {
    const now = Date.now();
    return {
      result: callback(...args),
      expiry: now + ttl
    };
  }, deps);
}

// Memoize component props comparison
export function arePropsEqual(prevProps, nextProps) {
  if (prevProps === nextProps) return true;
  
  const keys = Object.keys(prevProps);
  if (keys.length !== Object.keys(nextProps).length) return false;
  
  return keys.every(key => {
    const prev = prevProps[key];
    const next = nextProps[key];
    
    if (prev === next) return true;
    if (typeof prev !== typeof next) return false;
    if (typeof prev === 'function') return prev.toString() === next.toString();
    if (Array.isArray(prev)) {
      if (!Array.isArray(next)) return false;
      if (prev.length !== next.length) return false;
      return prev.every((item, i) => item === next[i]);
    }
    if (typeof prev === 'object') {
      return arePropsEqual(prev, next);
    }
    return false;
  });
}